<template>
    <section class="forgot-password">
        <header class="header">
            <h2 class="header__title">Forgot your password?</h2>

            <p class="header__message">Enter your email address below and we'll get you back on track.</p>
        </header>

        <div class="success-card" v-if="requestStatus">
            <img src="@/assets/icons/ic_error.png" class="icon">
            <p>Email Sent.</p>
        </div>

        <div class="error-card" v-if="error">
            <img src="@/assets/icons/ic_error.png" class="icon">

            <p>{{ error }}</p>
        </div>

        <form
            class="form"
            @submit.prevent="requestResetLink()"
        >
            <AppTextField
                class="form__input"
                type="email"
                placeholder="Email@info.com"
                required
                v-model="forgotPassword.email"
            >
                Email Address
            </AppTextField>

            <AppButton
                class="form__button"
                modifier="large-primary-ghost"
                :disabled="loading"
            >
                {{ loading ? 'Loading...' : 'Request Reset Link' }}
            </AppButton>

            <a
                class="form__link"
                @click.prevent="$router.push('/')"
            >
                Back to Sign In
            </a>
        </form>
    </section>
</template>

<script>
import Form from '@/class/Form'
import { mapFields } from 'vuex-map-fields'

export default {
	beforeRouteLeave (to, from, next) {
		this.clearPage()

		next()
	},

	computed: {
		...mapFields([
			'forgotPassword',
			'loading',
			'error',
			'requestStatus'
		])
	},

	methods: {
		/* Request Reset Link */
		async requestResetLink () {
			if (this.loading) return

			const { form, validated } = await this.validate()

			if (validated) {
				const formData = new FormData()
				formData.append('email', form.get('email'))

				this.$store.dispatch('requestReset', { form: formData, router: this.$router })
			}
		},

		validate () {
			const form = new Form(this.forgotPassword)

			const data = {
				form,
				validated: true
			}

			if (!form.isValidEmail('email')) {
				data.validated = false
				this.error = 'Please enter valid Email.'
			}

			return data
		},

		/* Before Route Leave */
		clearPage () {
			this.error = ''

			this.forgotPassword = {
				email: ''
			}

			this.requestStatus = false
		}
	}
}
</script>
